import { Asset } from 'src/redux/slices/Assets'
import Carousel from 'src/components/Carousel'
import { ButtonError } from '@flatsy/core/MaterialUi/Button'
import { ClassNameMap } from '@material-ui/styles'
import Information from '../Information'

export const renderIsImg = (asset: Asset | undefined): React.ReactNode => {
  return (
    asset?.img_urls &&
    asset?.img_urls.length !== 0 && (
      <>
        <Carousel asset={asset} noBorderRadius />
      </>
    )
  )
}

export const renderCancelButton = (
  classes: ClassNameMap<'cancel'>,
  handleCancel: () => Promise<void>
): React.ReactNode => {
  return (
    <ButtonError className={classes.cancel} onClick={handleCancel}>
      Annuler la candidature
    </ButtonError>
  )
}

export const renderApplicationInformation = (asset: Asset | undefined): React.ReactNode => {
  return <Information asset={asset} />
}
